
export class PlateSearch {
    Plate:string;
    State:string;
/**
 *
 */
constructor() {
    this.Plate="";
    this.State="";
}

}




// WEBPACK FOOTER //
// ./src/app/VIewModels/TowLocateViewModels/PlateSearch.ts